import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Plane } from "lucide-react";

const Footer = () => (
  <footer style={{ background: "#060d1f" }} className="text-slate-400">
    {/* Main grid */}
    <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
      {/* Brand */}
      <div className="md:col-span-1">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-8 h-8 bg-gradient-to-br from-sky-500 to-blue-700 rounded-lg flex items-center justify-center">
            <Plane size={16} className="text-white -rotate-45" />
          </div>
          <span
            className="text-base font-extrabold text-white"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            MyFly<span className="text-sky-400">Sky9</span>
          </span>
        </div>
        <p className="text-sm leading-relaxed text-slate-400 mb-5">
          Your trusted partner for affordable flights, expert travel assistance, and seamless bookings.
        </p>
        <a
          href="tel:+18663597599"
          className="inline-flex items-center gap-2 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold text-sm px-4 py-2.5 rounded-xl transition-all duration-200 pulse-glow"
        >
          <Phone size={14} />
          +1 866-359-7599
        </a>
      </div>

      {/* Quick Links */}
      <div>
        <h4 className="text-white font-bold text-sm mb-5 uppercase tracking-wider">Quick Links</h4>
        <ul className="space-y-3 text-sm">
          {[
            { to: "/", label: "Home" },
            { to: "/aboutus", label: "About Us" },
            { to: "/contactus", label: "Contact Us" },
          ].map(({ to, label }) => (
            <li key={to}>
              <Link to={to} className="hover:text-sky-400 transition-colors duration-200">{label}</Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Legal */}
      <div>
        <h4 className="text-white font-bold text-sm mb-5 uppercase tracking-wider">Policies</h4>
        <ul className="space-y-3 text-sm">
          {[
            { to: "/terms-and-conditions", label: "Terms & Conditions" },
            { to: "/privacy-policy", label: "Privacy Policy" },
            { to: "/cancellation-refund-policy", label: "Cancellation & Refund" },
            { to: "/fare-disclosure-policy", label: "Fare Disclosure" },
            { to: "/cookies-policy", label: "Cookies Policy" },
          ].map(({ to, label }) => (
            <li key={to}>
              <Link to={to} className="hover:text-sky-400 transition-colors duration-200">{label}</Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Contact */}
      <div>
        <h4 className="text-white font-bold text-sm mb-5 uppercase tracking-wider">Contact</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex items-center gap-2.5">
            <Phone size={14} className="text-sky-400 shrink-0" />
            <a href="tel:+18663597599" className="hover:text-sky-400 transition-colors">
              +1 866-359-7599
            </a>
          </li>
          <li className="flex items-center gap-2.5">
            <Mail size={14} className="text-sky-400 shrink-0" />
            <span>support@MyFlySky9.com</span>
          </li>
          {/* <li className="flex items-start gap-2.5">
            <MapPin size={14} className="text-sky-400 shrink-0 mt-0.5" />
            <span>🇺🇸 USA Office  
A-13188, Juliet Way  
Frisco, TX 75035
</span>
          </li> */}
<li className="flex items-start gap-2.5">
            <MapPin size={14} className="text-sky-400 shrink-0 mt-0.5" />
            <span>
{/* 🇮🇳 India Office   */}
9/62, Opp Kali Mata Mandir  
Dalhousie Road, Pathankot
</span>
</li>
        </ul>
      </div>
    </div>

    {/* Disclaimer */}
    <div
      className="border-t px-6 py-5"
      style={{ borderColor: "rgba(255,255,255,0.07)" }}
    >
      <p className="max-w-5xl mx-auto text-xs text-slate-500 text-center leading-relaxed">
        <strong className="text-slate-400">Disclaimer:</strong> Myflysky9 is owned and operated by Flyskynine Traveltech LLP, a registered entity in India. All services are provided in accordance with applicable jurisdictional regulations.{" "}
    
      </p>
    </div>

    {/* Copyright */}
    <div
      className="py-4 border-t"
      style={{ borderColor: "rgba(255,255,255,0.05)", background: "rgba(0,0,0,0.3)" }}
    >
      <p className="text-center text-xs text-slate-600">
        © {new Date().getFullYear()} MyFlySky9.com · All rights reserved · Operated by FlySky9 LLC
      </p>
    </div>
  </footer>
);

export default Footer;
